<script lang="ts">
  import '../../app.css';

  // Svelte/kit

  // UI components
  import TopMenu from '$lib/components/layout/TopMenu.svelte';
  import Sidebar from '$lib/components/layout/Sidebar.svelte';
  import SmallSidebar from '$lib/components/layout/SmallSidebar.svelte';

  // RoastLog
  import { sidebarHidden } from '$lib/Stores';

  // Others
  import { Toaster } from '$lib/components/ui/sonner';
  import { ModeWatcher } from 'mode-watcher';
  interface Props {
    children?: import('svelte').Snippet;
  }

  let { children }: Props = $props();

  const openMenu = () => {
    // console.log('Opening menu in the parent');
    sidebarHidden.set(false);
  };

  const closeMenu = () => {
    // console.log('Closing menu in the parent');
    sidebarHidden.set(true);
  };
</script>

<svelte:head>
  <title>RoastLogger</title>
</svelte:head>

<!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
<SmallSidebar on:closemenu={closeMenu} />

<div class="flex h-dvh flex-col">
  <div
    class="bg-background sticky top-0 z-50 flex
         h-16 flex-none shrink-0 justify-between
        gap-x-4 border-b-2 px-4
         sm:gap-x-6
         sm:px-6 lg:px-0
         "
  >
    <TopMenu on:openmenu={openMenu} />
  </div>

  <div class="my-2 flex-1 overflow-y-auto">
    <!-- Static sidebar for desktop -->
    <div class="px-2 max-lg:hidden lg:fixed lg:w-[30rem]">
      <Sidebar />
    </div>

    <ModeWatcher />

    <!-- Main content. Padding here should match the width of lef col. -->
    <div id="main-content" class="no-h-screen mx-5 lg:ml-[30rem]">
      {@render children?.()}
      <Toaster richColors position="bottom-right" />
    </div>
  </div>
</div>
